import React from "react";
import { IconProps } from "../icon";

export const Wind_03Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16.764 6.5a3 3 0 112.236 5h-6M6.764 4A3 3 0 119 9H2m8.764 11A3 3 0 1013 15H2"
    />
  </svg>
);
